export const blueFlameQuest = {
    id: 'blue_fire',
    titleKey: 'chapter_blue_flame',
    shortName: 'BLUEFIRE',
    date: '15.01.2026',
    status: 'completed',
    questMap: [
        {
            id: 'step_start_bluefire',
            label: {
                en: "Getting a quest / Read the EMERCOM leaflet",
                tr: "Görev alma / EMERCOM broşürünü oku",
                ru: "Получение квеста / Прочитать листовку МЧС"
            },
            type: 'start',
            isSubTask: false,
            details: {
                location: { en: "Woods / Interchange / The Labyrinth", tr: "Ormanlık / Değişim / The Labyrinth", ru: "Лес / Развязка / Лабиринт" },
                objective: {
                    en: "Pick up and read an EMERCOM leaflet or the Note by Item #1156 to start the chapter.",
                    tr: "Bölümü başlatmak için bir EMERCOM broşürünü veya Eşya #1156 Notunu al ve oku.",
                    ru: "Подберите и прочитайте листовку EMERCOM или записку о Предмете #1156, чтобы начать главу."
                },
                story: {
                    en: "During the raid on the office, some kind of special weapon went off on one of the roofs... I remember a bright blue flash before I blacked out. After that, all the electronics failed. I've never encountered such a powerful EMP weapon before. I need to find out what technology hit the city, and who's behind it.",
                    tr: "Ofise yaptığımız baskın sırasında çatılardan birinde özel bir silah patladı... Bayılmadan önce parlak mavi bir ışık hatırlıyorum. Ondan sonra tüm elektronik cihazlar bozuldu. Daha önce hiç bu kadar güçlü bir EMP silahıyla karşılaşmamıştım. Şehri vuran bu teknolojinin ne olduğunu ve arkasında kimin olduğunu bulmam gerekiyor.",
                    ru: "Во время рейда на офис на одной из крыш сработало какое-то особое оружие... Я помню яркую синюю вспышку перед тем, как отключился. После этого вся электроника вышла из строя. Я никогда раньше не сталкивался с таким мощным ЭМИ-оружием. Мне нужно узнать, что за технология ударила по городу и кто за этим стоит."
                },
                guideSteps: [
                    {
                        text: {
                            en: "Method 1 - Woods: Go to the Scav base / EMERCOM camp. Find the green shipping container. The leaflet is attached to the side of a white cabinet inside.",
                            tr: "Yöntem 1 - Ormanlık: Scav üssüne / EMERCOM kampına git. Yeşil nakliye konteynerini bul. Broşür, içerideki beyaz dolabın yan tarafına asılıdır.",
                            ru: "Способ 1 - Лес: Отправляйтесь на базу Диких / в лагерь EMERCOM. Найдите зеленый транспортный контейнер. Листовка прикреплена сбоку к белому шкафу внутри."
                        },
                        images: ['/Story/BlueFire/Start-WoodsMap.webp', '/Story/BlueFire/Start-WoodsContainer.webp']
                    },
                    {
                        text: {
                            en: "Method 2 - Interchange (Tent west of highway): Go to the tent west of the highway near the 'Path to River' extract. The leaflet is on the tent.",
                            tr: "Yöntem 2 - Değişim (Otoyolun batısındaki çadır): 'Path to River' çıkışının yakınında, otoyolun batısında bulunan çadıra git. Broşür çadırın üzerindedir.",
                            ru: "Способ 2 - Развязка (Палатка к западу от шоссе): Отправляйтесь к палатке к западу от шоссе рядом с выходом «Путь к реке». Листовка находится на палатке."
                        },
                        images: ['/Story/BlueFire/Start-InterchangeTent1.webp']
                    },
                    {
                        text: {
                            en: "Method 3 - Interchange (Highway tent): Go to the tent located directly on the highway. The leaflet is on the tent.",
                            tr: "Yöntem 3 - Değişim (Otoyol çadırı): Doğrudan otoyolun üzerinde bulunan çadıra git. Broşür çadırın üzerindedir.",
                            ru: "Способ 3 - Развязка (Палатка на шоссе): Отправляйтесь к палатке прямо на шоссе. Листовка находится на палатке."
                        },
                        images: ['/Story/BlueFire/Start-InterchangeTent2.webp']
                    },
                    {
                        text: {
                            en: "Method 4 - Interchange (ULTRA EMERCOM): Go to the EMERCOM medical unit on the first floor of the ULTRA mall. The leaflet is inside.",
                            tr: "Yöntem 4 - Değişim (ULTRA EMERCOM): ULTRA alışveriş merkezinin birinci katındaki EMERCOM sağlık birimine git. Broşür içeridedir.",
                            ru: "Способ 4 - Развязка (EMERCOM в Ультре): Отправляйтесь в медицинский блок EMERCOM на первом этаже ТЦ Ультра. Листовка находится внутри."
                        },
                        images: ['/Story/BlueFire/Start-InterchangeUltra.webp']
                    },
                    {
                        text: {
                            en: "Method 5 - The Labyrinth: Go to the prototype weapon area. The note is on a table.",
                            tr: "Yöntem 5 - The Labyrinth: Prototip silah alanına git. Not masanın üzerindedir.",
                            ru: "Способ 5 - Лабиринт: Отправляйтесь в зону прототипного оружия. Записка лежит на столе."
                        },
                        images: ['/Story/BlueFire/Start-Labyrinth.webp']
                    }
                ]
            }
        },
        {
            id: 'step_talk_mechanic_emp',
            label: {
                en: "Talk to Mechanic about the EMP blast",
                tr: "Mekanik ile EMP patlaması hakkında konuş",
                ru: "Поговорить с Механиком об ЭМИ-взрыве"
            },
            type: 'talk',
            isSubTask: false,
            details: {
                location: { en: "Menu / Traders", tr: "Menü / Satıcılar", ru: "Меню / Торговцы" },
                objective: {
                    en: "Visit Mechanic and ask him about the EMP blast.",
                    tr: "Mekanik'i ziyaret et ve ona EMP patlaması hakkında sorular sor.",
                    ru: "Посетите Механика и спросите его об ЭМИ-взрыве."
                },
                guideSteps: [
                    {
                        text: {
                            en: "Open the Traders menu. Select Mechanic. Complete the dialogue about the EMP blast.",
                            tr: "Satıcılar menüsünü aç. Mekanik'i seç. EMP patlaması hakkındaki diyalogu tamamla.",
                            ru: "Откройте меню торговцев. Выберите Механика. Завершите диалог об ЭМИ-взрыве."
                        }
                    }
                ]
            }
        },
        {
            id: 'step_find_device_fragment',
            label: {
                en: "Locate and obtain the device fragment",
                tr: "Cihaz parçasını bul ve al",
                ru: "Найти и забрать фрагмент устройства"
            },
            type: 'objective',
            isSubTask: false,
            details: {
                location: { en: "Streets of Tarkov", tr: "Tarkov'un sokakları", ru: "Улицы Таркова" },
                objective: {
                    en: "Find the Unknown device fragment at either the LexOs dealership or the Chekannaya 13 marked room.",
                    tr: "Bilinmeyen cihaz parçasını LexOs araba bayisinde veya Chekannaya 13 işaretli odasında bul.",
                    ru: "Найдите фрагмент неизвестного устройства либо в автосалоне LexOs, либо в меченой комнате на Чеканной 13."
                },
                warning: {
                    en: "Only ONE of the two keys is needed. The fragment goes into your quest inventory and is lost upon death.",
                    tr: "İki anahtardan SADECE BİRİ gereklidir. Parça, görev envanterine eklenir ve ölürseniz kaybolur.",
                    ru: "Нужен только ОДИН из двух ключей. Фрагмент попадает в квестовый инвентарь и теряется при смерти."
                },
                requiredItems: [
                    { en: "Unknown device fragment", tr: "Bilinmeyen cihaz parçası", ru: "Фрагмент неизвестного устройства" }
                ],
                guideSteps: [
                    {
                        text: {
                            en: "OPTION A - LexOs Car Dealership: Requires the 'Car dealership closed section key'. Go to the second-floor closed section. The device is inside a food container on a table. Watch out for Claymores!",
                            tr: "SEÇENEK A - LexOs Araba Bayisi: 'Araba bayisi kapalı bölüm anahtarı' (Car dealership closed section key) gerektirir. İkinci kattaki kapalı bölüme git. Cihaz, masanın üzerindeki bir yemek kabının içindedir. Claymore mayınlarına dikkat et!",
                            ru: "ВАРИАНТ А - Автосалон LexOs: Требуется «Ключ от закрытой секции автосалона». Отправляйтесь в закрытую секцию на втором этаже. Устройство находится в контейнере для еды на столе. Осторожно, мины Клеймор!"
                        },
                        images: ['/Story/BlueFire/Fragment-LexOsMap.webp', '/Story/BlueFire/Fragment-LexOsDoor.webp', '/Story/BlueFire/Fragment-LexOsItem.webp']
                    },
                    {
                        text: {
                            en: "OPTION B - Chekannaya 13 Apartments: Requires the 'Mysterious room marked key'. Enter through the broken window, go through the hole in the wall, and head downstairs to the locked room. The device is in a flower pot in the corner.",
                            tr: "SEÇENEK B - Chekannaya 13 Apartmanı: 'Gizemli oda işaretli anahtarı' (Mysterious room marked key) gerektirir. Kırık pencereden gir, duvardaki delikten geç ve alt kattaki kilitli odaya in. Cihaz köşedeki bir saksının içindedir.",
                            ru: "ВАРИАНТ Б - Жилой комплекс Чеканная 13: Требуется «Меченый ключ от таинственной комнаты». Войдите через разбитое окно, пройдите через дыру в стене и спуститесь вниз к запертой комнате. Устройство находится в цветочном горшке в углу."
                        },
                        images: ['/Story/BlueFire/Fragment-ChekMap.webp', '/Story/BlueFire/Fragment-ChekWindow.webp', '/Story/BlueFire/Fragment-ChekRoom.webp', '/Story/BlueFire/Fragment-ChekItem.webp']
                    }
                ]
            }
        },
        {
            id: 'step_handover_fragment',
            label: {
                en: "Hand over the device fragment to Mechanic",
                tr: "Cihaz parçasını Mekanik'e teslim et",
                ru: "Передать фрагмент устройства Механику"
            },
            type: 'talk',
            isSubTask: false,
            details: {
                location: { en: "Menu / Traders", tr: "Menü / Satıcılar", ru: "Меню / Торговцы" },
                objective: {
                    en: "Give the Unknown device fragment to Mechanic.",
                    tr: "Bilinmeyen cihaz parçasını Mekanik'e teslim et.",
                    ru: "Передайте фрагмент неизвестного устройства Механику."
                },
                guideSteps: [
                    {
                        text: {
                            en: "Visit Mechanic with the fragment in your quest inventory and hand it over.",
                            tr: "Cihaz parçası görev envanterindeyken Mekanik'i ziyaret et ve parçayı ona teslim et.",
                            ru: "Посетите Механика с фрагментом в вашем квестовом инвентаре и передайте его."
                        }
                    }
                ]
            }
        },
        {
            id: 'step_plant_hacking_device',
            label: {
                en: "Plant the hacking device in the server room in the Lab",
                tr: "Laboratuvar'daki sunucu odasına hackleme cihazını yerleştir",
                ru: "Заложить устройство взлома в серверной Лаборатории"
            },
            type: 'objective',
            isSubTask: false,
            details: {
                location: { en: "The Lab", tr: "Laboratuvar", ru: "Лаборатория" },
                objective: {
                    en: "Plant the Local network hacking device in the server room on the first floor of The Lab.",
                    tr: "Yerel ağ hackleme cihazını Laboratuvar'ın (The Lab) birinci katındaki sunucu odasına yerleştir.",
                    ru: "Заложите устройство для взлома локальной сети в серверной на первом этаже Лаборатории."
                },
                requiredItems: [
                    { en: "Local network hacking device (provided by Mechanic via mail)", tr: "Yerel ağ hackleme cihazı (Mekanik tarafından oyun içi posta ile gönderilir)", ru: "Устройство для взлома локальной сети (выдается Механиком по почте)" }
                ],
                guideSteps: [
                    {
                        text: {
                            en: "Go to the server room on the first floor of The Lab. Find the stash spot next to the office chairs.",
                            tr: "Laboratuvar'ın (The Lab) birinci katındaki sunucu odasına git. Ofis sandalyelerinin yanındaki yerleştirme noktasını bul.",
                            ru: "Отправляйтесь в серверную на первом этаже Лаборатории. Найдите место для закладки рядом с офисными креслами."
                        },
                        images: ['/Story/BlueFire/HackDevice-Map.webp', '/Story/BlueFire/HackDevice-Location.webp']
                    },
                    {
                        text: {
                            en: "Plant the hacking device and extract safely.",
                            tr: "Hackleme cihazını yerleştir ve haritadan güvenli bir şekilde çıkış yap.",
                            ru: "Заложите устройство для взлома и успешно эвакуируйтесь."
                        }
                    }
                ]
            }
        },
        {
            id: 'step_talk_mechanic_2',
            label: {
                en: "Talk to Mechanic",
                tr: "Mekanik ile konuş",
                ru: "Поговорить с Механиком"
            },
            type: 'talk',
            isSubTask: false,
            details: {
                location: { en: "Menu / Traders", tr: "Menü / Satıcılar", ru: "Меню / Торговцы" },
                objective: {
                    en: "Return to Mechanic after planting the hacking device.",
                    tr: "Hackleme cihazını yerleştirdikten sonra Mekanik'e geri dön.",
                    ru: "Вернитесь к Механику после закладки устройства для взлома."
                },
                guideSteps: [
                    {
                        text: {
                            en: "Visit Mechanic and complete the dialogue.",
                            tr: "Mekanik'i ziyaret et ve diyalogu tamamla.",
                            ru: "Посетите Механика и завершите диалог."
                        }
                    }
                ]
            }
        },
        {
            id: 'step_keep_or_handover',
            label: {
                en: "Keep the fragment or hand it over - CHOICE",
                tr: "Parçayı sakla veya teslim et - SEÇİM",
                ru: "Оставить фрагмент или передать — ВЫБОР"
            },
            type: 'talk',
            isSubTask: false,
            details: {
                location: { en: "Menu / Traders", tr: "Menü / Satıcılar", ru: "Меню / Торговцы" },
                objective: {
                    en: "Decide whether to keep the Item 1156 fragment for yourself or give it to Mechanic.",
                    tr: "Eşya 1156 parçasını kendine mi saklayacağına yoksa Mekanik'e mi vereceğine karar ver.",
                    ru: "Решите, оставить ли фрагмент Предмета 1156 себе или отдать его Механику."
                },
                warning: {
                    en: "Keeping the fragment unlocks the 'Better Served' achievement. Handing it over rewards you with 1,500,000 Roubles.",
                    tr: "Parçayı elinde tutmak 'Better Served' (Daha İyi Hizmet) başarımının kilidini açar. Parçayı Mekanik'e teslim etmek ise 1.500.000 Ruble ödül verir.",
                    ru: "Если оставить фрагмент себе, вы получите достижение «Лучше подавать холодным». Передача фрагмента принесет вам 1 500 000 рублей."
                },
                guideSteps: [
                    {
                        text: {
                            en: "CHOICE A: Keep the fragment -> Unlocks the 'Better Served' achievement.",
                            tr: "SEÇENEK A: Parçayı sakla -> 'Better Served' başarımını açar.",
                            ru: "ВЫБОР А: Оставить фрагмент себе -> Открывает достижение «Лучше подавать холодным»."
                        }
                    },
                    {
                        text: {
                            en: "CHOICE B: Hand it over to Mechanic -> Receive 1,500,000 Roubles.",
                            tr: "SEÇENEK B: Mekanik'e teslim et -> 1.500.000 Ruble kazandırır.",
                            ru: "ВЫБОР Б: Передать Механику -> Получить 1 500 000 рублей."
                        }
                    }
                ]
            }
        },
        {
            id: 'step_find_lead_1156',
            label: {
                en: "Find a lead on Item 1156",
                tr: "Eşya 1156 hakkında ipucu bul",
                ru: "Найти зацепку о Предмете 1156"
            },
            type: 'objective',
            isSubTask: false,
            details: {
                location: { en: "Ground Zero / Lighthouse / The Lab", tr: "Ground Zero / Deniz feneri / Laboratuvar", ru: "Эпицентр / Маяк / Лаборатория" },
                objective: {
                    en: "Find and read the Note mentioning Item #1156.",
                    tr: "Eşya #1156'dan bahseden notu bul ve oku.",
                    ru: "Найдите и прочитайте записку с упоминанием Предмета #1156."
                },
                requiredItems: [
                    { en: "Note mentioning Item #1156", tr: "Eşya #1156'dan bahseden not", ru: "Записка с упоминанием Предмета #1156" }
                ],
                guideSteps: [
                    {
                        text: {
                            en: "Location 1 - Ground Zero (Level 21+): Office #4 on the second floor of the TerraGroup main building. Requires the TerraGroup science office key.",
                            tr: "Konum 1 - Ground Zero (Seviye 21+): TerraGroup ana binasının ikinci katındaki 4 numaralı ofis. TerraGroup bilim ofisi anahtarı gerektirir.",
                            ru: "Место 1 - Эпицентр (Уровень 21+): Офис №4 на втором этаже главного здания TerraGroup. Требуется ключ от научного офиса TerraGroup."
                        },
                        images: ['/Story/BlueFire/Lead-GZMap.webp', '/Story/BlueFire/Lead-GZOffice.webp', '/Story/BlueFire/Lead-GZNote.webp']
                    },
                    {
                        text: {
                            en: "Location 2 - Lighthouse: Inside the northern blue chalet, on the first-floor bookshelf near the central stairs.",
                            tr: "Konum 2 - Deniz Feneri: Kuzeydeki mavi dağ evinde (chalet), birinci katta orta merdivenlerin yanındaki kitaplıkta.",
                            ru: "Место 2 - Маяк: Внутри северного синего шале, на книжной полке первого этажа рядом с центральной лестницей."
                        },
                        images: ['/Story/BlueFire/Lead-LighthouseMap.webp', '/Story/BlueFire/Lead-LighthouseNote.webp']
                    },
                    {
                        text: {
                            en: "Location 3 - The Lab: On a desk inside Office O22 on the second floor.",
                            tr: "Konum 3 - Laboratuvar: İkinci kattaki O22 numaralı ofiste bulunan bir masanın üzerinde.",
                            ru: "Место 3 - Лаборатория: На столе в офисе O22 на втором этаже."
                        },
                        images: ['/Story/BlueFire/Lead-LabMap.webp', '/Story/BlueFire/Lead-LabNote.webp']
                    }
                ]
            }
        },
        {
            id: 'step_investigate_rus_post',
            label: {
                en: "Investigate the Rus Post office",
                tr: "Rus Posta ofisini araştır",
                ru: "Обыскать отделение Почты России"
            },
            type: 'objective',
            isSubTask: false,
            details: {
                location: { en: "Streets of Tarkov", tr: "Tarkov'un sokakları", ru: "Улицы Таркова" },
                objective: {
                    en: "Pick up and listen to the 3 audio tapes located at the Rus Post office.",
                    tr: "Rus Posta ofisinde bulunan 3 ses kasetini al ve dinle.",
                    ru: "Найдите и прослушайте 3 аудиокассеты, находящиеся в отделении Почты России."
                },
                requiredItems: [
                    { en: "Rus Post audio tape 11.05 / 001", tr: "Rus Posta ses kaseti 11.05 / 001", ru: "Аудиокассета Почты России 11.05 / 001" },
                    { en: "Rus Post audio tape 11.05 / 002", tr: "Rus Posta ses kaseti 11.05 / 002", ru: "Аудиокассета Почты России 11.05 / 002" },
                    { en: "Rus Post audio tape 11.05 / 003", tr: "Rus Posta ses kaseti 11.05 / 003", ru: "Аудиокассета Почты России 11.05 / 003" }
                ],
                guideSteps: [
                    {
                        text: {
                            en: "Go to the Rus Post office on the Streets of Tarkov.",
                            tr: "Tarkov'un sokakları haritasındaki Rus Posta ofisine git.",
                            ru: "Отправляйтесь в отделение Почты России на Улицах Таркова."
                        },
                        images: ['/Story/BlueFire/PostOffice-Map.webp']
                    },
                    {
                        text: {
                            en: "Tape #1: On the desk with a monitor behind the counter.",
                            tr: "Kaset #1: Bankonun arkasında, üzerinde monitör bulunan masanın üzerinde.",
                            ru: "Кассета #1: На столе с монитором за стойкой."
                        },
                        images: ['/Story/BlueFire/Tape1-Location.webp']
                    },
                    {
                        text: {
                            en: "Tape #2: On top of the coffee vending machine next to the storage room.",
                            tr: "Kaset #2: Depo odasının yanındaki kahve otomatının üstünde.",
                            ru: "Кассета #2: На кофейном автомате рядом с кладовой."
                        },
                        images: ['/Story/BlueFire/Tape2-Location.webp']
                    },
                    {
                        text: {
                            en: "Tape #3: On a desk in the back office, accessible through the hallway behind the counter.",
                            tr: "Kaset #3: Bankonun arkasındaki koridordan ulaşılan arka ofisteki bir masanın üzerinde.",
                            ru: "Кассета #3: На столе в заднем офисе, куда можно попасть через коридор за стойкой."
                        },
                        images: ['/Story/BlueFire/Tape3-Location.webp']
                    }
                ]
            }
        },
        {
            id: 'step_find_rus_post_car',
            label: {
                en: "Locate the Rus Post Car",
                tr: "Rus Posta aracını bul",
                ru: "Найти автомобиль Почты России"
            },
            type: 'objective',
            isSubTask: false,
            details: {
                location: { en: "Streets of Tarkov", tr: "Tarkov'un sokakları", ru: "Улицы Таркова" },
                objective: {
                    en: "Find the Rus Post car parked in front of the post office.",
                    tr: "Posta ofisinin önünde park halinde olan Rus Posta aracını bul.",
                    ru: "Найдите автомобиль Почты России, припаркованный перед почтовым отделением."
                },
                guideSteps: [
                    {
                        text: {
                            en: "Head to the front of the Rus Post office. The car is parked right there.",
                            tr: "Rus Posta ofisinin önüne git. Araç tam oraya park edilmiştir.",
                            ru: "Подойдите к главному входу в отделение Почты России. Машина припаркована прямо там."
                        },
                        images: ['/Story/BlueFire/PostCar-Map.webp', '/Story/BlueFire/PostCar-View.webp']
                    }
                ]
            }
        },
        {
            id: 'step_obtain_blueprint',
            label: {
                en: "Obtain the blueprint for Item 1156",
                tr: "Eşya 1156'nın teknik çizimini al",
                ru: "Получить чертёж Предмета 1156"
            },
            type: 'objective',
            isSubTask: false,
            details: {
                location: { en: "Streets of Tarkov", tr: "Tarkov'un sokakları", ru: "Улицы Таркова" },
                objective: {
                    en: "Retrieve the Item 1156 specification blueprint from the back of the Rus Post car.",
                    tr: "Rus Posta aracının arkasından Eşya 1156'nın teknik çizimini (blueprint) al.",
                    ru: "Заберите чертеж спецификации Предмета 1156 из задней части автомобиля Почты России."
                },
                requiredItems: [
                    { en: "Rus Post car key (spawns next to the back right wheel every raid)", tr: "Rus Posta araba anahtarı (her baskında sağ arka tekerleğin yanında belirir)", ru: "Ключ от машины Почты России (появляется рядом с правым задним колесом в каждом рейде)" },
                    { en: "Item 1156 specification", tr: "Eşya 1156 teknik çizimi", ru: "Спецификация Предмета 1156" }
                ],
                guideSteps: [
                    {
                        text: {
                            en: "Find the Rus Post car key on the ground near the back right wheel of the vehicle. It spawns there in every raid.",
                            tr: "Aracın sağ arka tekerleğinin hemen yanındaki yerde Rus Posta araba anahtarını bul. Bu anahtar her baskında orada belirir.",
                            ru: "Найдите ключ от машины Почты России на земле рядом с правым задним колесом автомобиля. Он появляется там в каждом рейде."
                        },
                        images: ['/Story/BlueFire/CarKey-Location.webp']
                    },
                    {
                        text: {
                            en: "Use the key to unlock the trunk of the car. The blueprint is located inside.",
                            tr: "Aracın bagajını açmak için anahtarı kullan. Teknik çizim içeridedir.",
                            ru: "Используйте ключ, чтобы открыть багажник машины. Чертеж находится внутри."
                        },
                        images: ['/Story/BlueFire/Blueprint-Location.webp', '/Story/BlueFire/Blueprint-Item.webp']
                    }
                ]
            }
        },
        {
            id: 'step_complete_bluefire',
            label: {
                en: "Complete the Blue Fire chapter",
                tr: "Mavi Alev bölümünü tamamla",
                ru: "Завершить главу «Синий Огонь»"
            },
            type: 'talk',
            isSubTask: false,
            details: {
                location: { en: "Menu / Traders", tr: "Menü / Satıcılar", ru: "Меню / Торговцы" },
                objective: {
                    en: "Finish the final objective to complete the Blue Fire chapter.",
                    tr: "Mavi Alev (Blue Fire) bölümünü tamamlamak için son görevi yerine getir.",
                    ru: "Выполните последнюю задачу, чтобы завершить главу «Синий Огонь»."
                },
                guideSteps: [
                    {
                        text: {
                            en: "Complete all the objectives and speak with Mechanic to finish the chapter. This unlocks the 'Inferno' achievement.",
                            tr: "Tüm görev hedeflerini tamamla ve bölümü bitirmek için Mekanik ile konuş. Bu işlem 'Inferno' başarımının kilidini açar.",
                            ru: "Завершите все задачи и поговорите с Механиком, чтобы закончить главу. Это откроет достижение «Инферно»."
                        }
                    }
                ]
            }
        }
    ]
};